var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var DependentAdult = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.99991 7C8.99991 5.34315 10.3431 4 11.9999 4C13.6568 4 14.9999 5.34315 14.9999 7C14.9999 8.65685 13.6568 10 11.9999 10C10.3431 10 8.99991 8.65685 8.99991 7ZM11.9999 2C9.23848 2 6.99991 4.23858 6.99991 7C6.99991 8.50906 7.66844 9.86198 8.72549 10.7788C6.66086 11.8221 5.14633 13.826 4.80344 16.2508L4.01022 21.86C3.93289 22.4068 4.3135 22.9128 4.86035 22.9901C5.40719 23.0675 5.91319 22.6869 5.99052 22.14L6.78374 16.5308C7.15125 13.932 9.37565 12 12.0004 12C14.6251 12 16.8495 13.932 17.217 16.5308L18.0102 22.14C18.0876 22.6869 18.5935 23.0675 19.1404 22.9901C19.6872 22.9128 20.0679 22.4068 19.9905 21.86L19.1973 16.2508C18.8544 13.8258 17.3396 11.8217 15.2747 10.7785C16.3315 9.86169 16.9999 8.5089 16.9999 7C16.9999 4.23858 14.7613 2 11.9999 2Z", fill: "#182023" }) })));
};
